import { http } from 'interfaces'
import { type RecordNavigationResult } from 'interfaces/navigation'

export type { RecordNavigationResult }

const NAVIGATION_PATH = (id: number): string => `/api/v1/us/leadership-officers/${id}/navigation/`

export async function getLeadershipOfficerNavigation (
  leadershipOfficerId: number,
  sortBy?: string
): Promise<RecordNavigationResult> {
  const params = new URLSearchParams()
  if (sortBy != null && sortBy.length > 0) params.set('sort', sortBy)
  const query = params.toString()
  const url = query.length > 0
    ? `${NAVIGATION_PATH(leadershipOfficerId)}?${query}`
    : NAVIGATION_PATH(leadershipOfficerId)
  try {
    const response = await http.get<{ result: RecordNavigationResult }>(url)
    return response.data.result
  } catch (error) {
    console.warn('[leadershipOfficerNavigation] failed to fetch neighbours; falling back to no-neighbours', error)
    return { previousId: null, nextId: null }
  }
}
